import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../stores/Hooks';
import { CategoryComponent } from '../components/CategoryComponent';
import { ModalTypeEnum } from '../stores/libraries/ModalLibrary';
import { TextInputComponent } from '../components/FormComponents/TextInputComponent';
import { SwitchableTextInputComponent } from '../components/FormComponents/SwitchableTextInputComponent';
import { CheckInputComponent } from '../components/FormComponents/CheckInputComponent';
import { InfoPageRightBlock } from './RightBlock/InfoPageRightBlock';

export const InfoPage: React.FC<any> = observer(
	() =>
	{
		const { uiState } = useStores();
		const store = uiState.info;

		function SortedCategories()
		{
			return Array.from(uiState.register.SelectedServiceCategories)
				.sort((a, b) =>
				{
					if (a[1].Category.OrderText > b[1].Category.OrderText) return 1;
					if (a[1].Category.OrderText < b[1].Category.OrderText) return -1;
					return 0;
				});
		}

		return (
				<div className="row no-gutters scrolled-container">
					<div className="col-lg">
						<div className="main-steps-form">
							<div className="info-on-mobile d-lg-none">
								<button
									className="text-primary text-center link d-flex align-items-center f-14"
									type="button"
									onClick={() => uiState.modal.ShowComponent("Информация по разделу", InfoPageRightBlock)}
								>Информация по разделу <img src="./i/icons/question.svg" className="ml-2" alt="Информация по разделу" /></button>
							</div>
							<div className="form-block-container">
								<div className="form-block form-block-bordered mb-4">
									<div className="form-block-header modal-header">Общие сведения об организации</div>
									<div className="row">
										<div className="col-xl-6 mb-2 mb-md-3 mb-lg-4">
											<TextInputComponent
												IsRequired={true}
												Error="Некорректное наименование организации"
												IsDisabled={store.OrganizationName.IsDisabled}
												IsValid={store.OrganizationName.IsValid}
												Label="Краткое наименование"
												MaxLength={1000}
												Placeholder="Введите наименование организации"
												Value={store.OrganizationName.Value ?? ""}
												OnChange={(value: string) => store.OrganizationName.setValue(value)}
												OnValidate={() => store.OrganizationName.Validate()}
												AutoComplete="organization"
											/>
										</div>
										<div className="col-md-6 col-xl-3 mb-2 mb-md-3 mb-lg-4">
											<TextInputComponent
												IsRequired={true}
												Error="Некорректный ИНН"
												IsDisabled={store.OrganizationInn.IsDisabled}
												IsValid={store.OrganizationInn.IsValid}
												Label="ИНН"
												MaxLength={10}
												Placeholder="Введите ИНН"
												Value={store.OrganizationInn.Value ?? ""}
												OnChange={(value: string) => store.OrganizationInn.setValue(value)}
												OnValidate={() => store.OrganizationInn.Validate()}
											/>
										</div>
										<div className="col-md-6 col-xl-3 mb-2 mb-md-3 mb-lg-4">
											<TextInputComponent
												IsRequired={true}
												Error="Некорректный КПП"
												IsDisabled={store.OrganizationKpp.IsDisabled}
												IsValid={store.OrganizationKpp.IsValid}
												Label="КПП"
												MaxLength={9}
												Placeholder="Введите КПП"
												Value={store.OrganizationKpp.Value ?? ""}
												OnChange={(value: string) => store.OrganizationKpp.setValue(value)}
												OnValidate={() => store.OrganizationKpp.Validate()}
											/>
										</div>
									</div>
									<div className="row">
										<div className="col-xl-6 mb-2 mb-md-3 mb-lg-4">
											<TextInputComponent
												IsRequired={true}
												Error="Некорректная фамилия"
												IsDisabled={store.OrganizationHeadLastName.IsDisabled}
												IsValid={store.OrganizationHeadLastName.IsValid}
												Label="Фамилия руководителя"
												MaxLength={255}
												Placeholder="Введите фамилию руководителя"
												Value={store.OrganizationHeadLastName.Value ?? ""}
												OnChange={(value: string) => store.OrganizationHeadLastName.setValue(value)}
												OnValidate={() => store.OrganizationHeadLastName.Validate()}
												AutoComplete="family-name"
											/>
										</div>
										<div className="col-xl-6 mb-2 mb-md-3 mb-lg-4">
											<TextInputComponent
												IsRequired={true}
												Error="Некорректное имя"
												IsDisabled={store.OrganizationHeadFirstName.IsDisabled}
												IsValid={store.OrganizationHeadFirstName.IsValid}
												Label="Имя руководителя"
												MaxLength={255}
												Placeholder="Введите имя руководителя"
												Value={store.OrganizationHeadFirstName.Value ?? ""}
												OnChange={(value: string) => store.OrganizationHeadFirstName.setValue(value)}
												OnValidate={() => store.OrganizationHeadFirstName.Validate()}
												AutoComplete="given-name"
											/>
										</div>
									</div>
								<div className="row">
										<div className="col-xl-6 mb-2 mb-md-3 mb-lg-4 mb-xl-0">
											<SwitchableTextInputComponent
												IsRequired={store.OrganizationHeadSecondNameExists.Value ?? false}
												Error="Некорректное отчество"
												IsTextDisabled={store.OrganizationHeadSecondName.IsDisabled}
												IsCheckDisabled={store.OrganizationHeadSecondName.IsDisabled}
												IsValid={store.OrganizationHeadSecondName.IsValid}
												Label="Отчество руководителя"
												MaxLength={255}
												Placeholder={store.OrganizationHeadSecondNameExists.Value ? "Введите отчество руководителя" : ""}
												Value={store.OrganizationHeadSecondName.Value ?? ""}
												OnTextChange={(value: string) => store.OrganizationHeadSecondName.setValue(value)}
												IsExisted={store.OrganizationHeadSecondNameExists.Value ?? false}
												OnCheckChange=
												{
													(value: boolean) =>
													{
														if (!value) store.OrganizationHeadSecondName.setValue("");
														store.OrganizationHeadSecondNameExists.setValue(value);
													}
												}
												OnValidate={() => store.OrganizationHeadSecondName.Validate()}
												AutoComplete="additional-name"
											/>
										</div>
										<div className="col-xl-6">
											<TextInputComponent
												IsRequired={true}
												Error="Некорректная должность"
												IsDisabled={store.OrganizationHeadPosition.IsDisabled}
												IsValid={store.OrganizationHeadPosition.IsValid}
												Label="Должность руководителя"
												MaxLength={255}
												Placeholder="Введите должность руководителя"
												Value={store.OrganizationHeadPosition.Value ?? ""}
												OnChange={(value: string) => store.OrganizationHeadPosition.setValue(value)}
												OnValidate={() => store.OrganizationHeadPosition.Validate()}
											/>
										</div>
									</div>
								</div>
								{
									SortedCategories().map(([key, value], index) =>
									{
										return (<CategoryComponent key={key} lib={value} order={index} />)
									})
								}
								<hr className="d-lg-none form-block-mobile-separator" />
								<div className="form-block pb-4 pb-lg-0">
									<CheckInputComponent
										Error="Необходимо подтвердить согласие"
										IsDisabled={store.AgreementCheck.IsDisabled}
										IsValid={store.AgreementCheck.IsValid}
										Label={(<>Подтверждаю согласие&nbsp;
											<button
												type="button"
												className="btn-as-link"
												onClick={() => uiState.modal.setShowModal(true, ModalTypeEnum.Agreement)}
											>на обработку персональных данных</button></>)}
										Value={store.AgreementCheck.Value ?? false}
										OnChange={(value: boolean) => store.AgreementCheck.setValue(value)}
										OnValidate={() => store.AgreementCheck.Validate()}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-auto sidebar d-none d-lg-block">
						<InfoPageRightBlock />
					</div>
				</div>
		);
	}
)
